<!-- src\domains\spl-navegantes\partials\PassesReportList.vue -->
<script>
  import ResponsiveTable from "@/core/components/table/ResponsiveTable"

  export default {
    components: { ResponsiveTable },
    props: { filters: { type: Object, default: () => ({}) } },

    data() {
      return {
        status: "pending",
        headers: [
          {
            value: "matricula",
            text: "Matrícula",
          },
          {
            value: "nome",
            text: "Beneficiário",
          },
          {
            value: "categoria",
            text: "Categoria",
          },
          {
            value: "modalidade",
            text: "Modalidade",
          },
          {
            value: "quantidade",
            text: "Quantidade",
          },
          {
            value: "data",
            text: "Data",
          },
          {
            value: "municipio",
            text: "Município",
          },
        ],

        page: 1,
        perPage: 10,

        items: [],
        pagination: { current_page: 1, per_page: 10, total: 0, last_page: 1 },

        loading: false,

        municipiosMap: {
          4540: "Itajaí",
          4583: "Navegantes",
        },
      }
    },

    computed: {
      totalRegistros() {
        return Number(this.pagination?.total || 0)
      },
      totalPassesPagina() {
        return (this.items || []).reduce(
          (acc, r) => acc + Number(r.quantidade || 0),
          0
        )
      },
    },

    watch: {
      filters: {
        deep: true,
        handler() {
          this.page = 1
        },
      },
    },

    mounted() {
      this.load()
    },

    methods: {
      resetAndReload() {
        this.page = 1
        this.load()
      },

      buildPayload() {
        const f = this.filters || {}

        return {
          search: f.search ? String(f.search).trim() : null,

          filters: {
            // padrão Beneficiários: arrays
            categoria: f.categoria_id ? [String(f.categoria_id)] : [],
            modalidade: f.modalidade_id ? [String(f.modalidade_id)] : [],
            municipio: f.municipio_id ? [String(f.municipio_id)] : [],

            // período por datas
            periodo_inicial: f.periodo_inicial || null,
            periodo_final: f.periodo_final || null,
          },

          orderBy: { dtalteracao: "DESC" },
          per_page: this.perPage,
        }
      },

      async load() {
        if (this.loading) {
          return
        }
        this.loading = true

        this.status = "pending"
        this.$Progress.start()

        try {
          const resp = await this.$axios.post(
            `/api/spl-navegantes/passes/relatorio?page=${this.page}`,
            this.buildPayload()
          )

          const p = resp.data?.sucess || {}
          const raw = Array.isArray(p.data) ? p.data : []

          this.items = raw.map((item) => {
            const municipioId =
              item.municipio_id != null ? String(item.municipio_id) : ""

            return {
              ...item,
              municipio_id: municipioId,
              municipio: this.municipiosMap[municipioId] || municipioId,
            }
          })

          this.pagination = {
            current_page: p.current_page || this.page,
            per_page: p.per_page || this.perPage,
            total: p.total || 0,
            last_page: p.last_page || 1,
          }

          this.status = "finished"
        } catch (e) {
          this.items = []
          this.pagination = {
            current_page: 1,
            per_page: this.perPage,
            total: 0,
            last_page: 1,
          }
          this.status = "rejected"
          this.$toast?.error?.({
            message: e.response?.data?.error || "Erro ao carregar relatório.",
          })
        } finally {
          this.loading = false
          this.$Progress.finish()
        }
      },

      handlePaginate(page) {
        this.page = page
        this.load()
      },
    },
  }
</script>

<template>
  <div>
    <ResponsiveTable
      :headers="headers"
      :data="items"
      :pagination="pagination"
      :disabled="status === 'pending'"
      :status="status"
      @changePage="handlePaginate"
    />
  </div>
</template>
